// core
import { Injectable } from '@angular/core';

// services
import { ApiService } from '../services/api.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigService extends ApiService {
  data!: any;

  central(): Promise<any> {
    return this.get('/config/central').toPromise().then((response: any) => {
      this.data = response;
      return response;
    });
  }

  portal(): Promise<any> {
    return this.get('/config/portal').toPromise().then((response: any) => {
      this.data = response;
      return response;
    });
  }
}
